import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDoctors,
  addDoctor,
  updateDoctor,
  getDoctorById,
  linkDoctorToMedicine,
  deleteDoctor,
  activeOrInactiveDoctor,
  modifyTarget,
  getDoctorStatistics,
  getDoctorDashboardStats,
} from "../../../api/doctor/doctorThunk";
import { createAsyncCases } from "../../../helpers/reduxUtils";
import { getAllDoctorDashboard } from "../../../api/doctor/doctorApi";
const initialState = {
  items: [],
  status: "idle",
  loading: null,
  error: null,
  totalRowsCount: 0,
  selectedItem: null,
  statistics: null,
  dashboardStats: null,
};
const doctorSlice = createSlice({
  name: "doctors",
  initialState,
  reducers: {
    handleSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    //fetch all doctor
    createAsyncCases(builder, fetchDoctors, {
      fulfilled: (state, action) => {
        state.items = action?.payload?.data || [];
        state.totalRowsCount = action?.payload?.pagination?.totalRowsCount;
      },
    });
    createAsyncCases(builder, addDoctor, { fulfilled(state, action) { } });
    createAsyncCases(builder, updateDoctor, { fulfilled(state, action) { } });
    createAsyncCases(builder, deleteDoctor, { fulfilled(state, action) { } });
    createAsyncCases(builder, getDoctorById, {
      fulfilled(state, action) {
        state.selectedItem = action?.payload;
      },
    });
    createAsyncCases(builder, linkDoctorToMedicine, {
      fulfilled(state, action) { },
    });
    createAsyncCases(builder, activeOrInactiveDoctor, {
      fulfilled(state, action) { },
    });
    createAsyncCases(builder, modifyTarget, {
      fulfilled(state, action) {
        toast.success("Target Modified Successfully");
      },
    });
    createAsyncCases(builder, getDoctorDashboardStats, {
      fulfilled(state, action) {
        state.dashboardStats = action.payload;
      },
    });
    createAsyncCases(builder, getDoctorStatistics, {
      fulfilled(state, action) {
        state.statistics = action.payload;
      },
    });
  },
});
export const { handleSelectedItem } = doctorSlice.actions;
export default doctorSlice.reducer;
